module.exports = __webpack_public_path__ + "static/TabletHover-66241081a5c6fd8229fb825fc4c88f14.png";